

























import Vue from 'vue';
import { BListGroup, BListGroupItem } from 'bootstrap-vue';
import { SectionMap } from '@/common/types';

export default Vue.extend({
  data: () => ({
    types: {
      hot: {
        icon: '🔥',
        name: 'Hot',
      },
      trending: {
        icon: '📈',
        name: 'Trending',
      },
      fresh: {
        icon: '🕒',
        name: 'Fresh',
      },
    },
  }),
  computed: {
    sections(): SectionMap {
      return this.$store.state.sections;
    },
  },
  created() {
    this.$store.dispatch('fetchSections');
  },
  components: { BListGroup, BListGroupItem },
});
